import { useTranslation } from 'react-i18next';

export interface SurveyProps {
    lastModificationDate: string
    surveyid: number
    name: string
    status: SurveyStatus
    dashboardCount: number
    dateResult?: string
    shareResult?: {
        status: string
        count: number
    }
    defaultDashboardId?: number
    customSurveyTitle?: string
    hotAlertCount?: number
    toTreatHotAlertCount?: number
    sharesCount?: number
    lastSynchronizationDate: string
    canCreateDashboard: boolean
}

export enum SurveyStatus {
    IN_PREPARATION = 'IN_PREPARATION',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    ARCHIVED = 'ARCHIVED',
}

export const SurveyStatusToLabel = {
    IN_PREPARATION: 'En préparation',
    IN_PROGRESS: 'En cours',
    COMPLETED: 'Terminé',
    ARCHIVED: 'Archivé',
};

export enum SurveyTemporalFilterType {
    VAGUE = 'VAGUE',
    DATE = 'DATE',
}

export const SurveyTemporalFilterTypeToLabel = (temporalType: SurveyTemporalFilterType) => {
    const { t } = useTranslation('settings');

    switch (temporalType) {
        case SurveyTemporalFilterType.VAGUE:
            return t('surveys.modal.createSurveyForm.temporalTypes.wave');
        case SurveyTemporalFilterType.DATE:
            return t('surveys.modal.createSurveyForm.temporalTypes.answerDate');
        default:
            return '';
    }
};

export enum SurveyDefaultDatePeriod {
    CURRENT_DAY = 'CURRENT_DAY',
    CURRENT_MONTH = 'CURRENT_MONTH',
    CURRENT_TRIM = 'CURRENT_TRIM',
    CURRENT_YEAR = 'CURRENT_YEAR',
    ALL = 'ALL',
}

export const SurveyDefaultDatePeriodToLabel = (defaultDatePeriod: SurveyDefaultDatePeriod) => {
    const { t } = useTranslation('settings');

    switch (defaultDatePeriod) {
        case SurveyDefaultDatePeriod.CURRENT_DAY:
            return t('surveys.modal.createSurveyForm.defaultDatePeriods.currentDay');
        case SurveyDefaultDatePeriod.CURRENT_MONTH:
            return t('surveys.modal.createSurveyForm.defaultDatePeriods.currentMonth');
        case SurveyDefaultDatePeriod.CURRENT_TRIM:
            return t('surveys.modal.createSurveyForm.defaultDatePeriods.currentTrim');
        case SurveyDefaultDatePeriod.CURRENT_YEAR:
            return t('surveys.modal.createSurveyForm.defaultDatePeriods.currentYear');
        case SurveyDefaultDatePeriod.ALL:
            return t('surveys.modal.createSurveyForm.defaultDatePeriods.all');
        default:
            return '';
    }
};

export enum SurveyTemporalityType {
    WEEK = 'WEEK',
    QUARTER = 'QUARTER',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

export interface SurveyToCreateProps {
    id: number;
    schema_name: string;
    name: string;
    slug: string;
    display: boolean;
    activate_synchronization: boolean;
    default_weight: number;
    rank: number;
    status: SurveyStatus;
    temporal_filter_type: SurveyTemporalFilterType;
    default_date_period: SurveyDefaultDatePeriod;
    context: string;
    has_quartile: boolean;
    can_export_hot_alert: boolean;
    can_create_dashboard: boolean;
    has_to_anonymate_responses: boolean;
    anonymization_limit_days?: number;
    has_translation: boolean;
}

export interface SurveyForConfigurationProps {
    name: string,
    surveyid: number,
    shortname: string,
    display: boolean,
    hassynchactived: boolean,
    comment: string,
    defaultweight: number,
    surveyidHistorique: number,
    questionidEndinterviewHistorique: number,
    rank: number,
    questionidVague: number,
    status: SurveyStatus,
    lastModificationDate: Date,
    schemaName: string,
    temporalFilterType: SurveyTemporalFilterType,
    defaultDatePeriod: SurveyDefaultDatePeriod,
    canExportHotAlert: boolean,
    canCreateDashboard: boolean,
    hasToAnonymate: boolean,
    anonymizationLimitDays: number,
    createdby: string,
    createdat: Date,
    clientName: string
    context?: string
}
